import { Link } from "react-router-dom";
import { Building2, ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, subtitle, effectiveDate, children, testid }) => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid={testid}>
      {/* Header */}
      <header className="bg-emerald-900 text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-home-link">
            <img src="/cpc-logo.png" alt="Comprehensive Pain Consultants" className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm text-emerald-100 hover:text-white transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>

      {/* Title */}
      <div className="bg-white border-b border-stone-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-emerald-900" style={{ fontFamily: "Manrope, sans-serif" }}>
            {title}
          </h1>
          {subtitle && <p className="mt-3 text-stone-600 text-base">{subtitle}</p>}
          {effectiveDate && (
            <p className="mt-4 text-sm text-stone-400">Effective date: {effectiveDate}</p>
          )}
        </div>
      </div>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="prose-legal space-y-8">{children}</div>
      </main>

      {/* Footer */}
      <footer className="py-10 px-4 bg-stone-900 text-stone-400">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <span>© {new Date().getFullYear()} Comprehensive Pain Consultants. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-emerald-400 transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/plaid-privacy" className="hover:text-emerald-400 transition-colors" data-testid="footer-plaid-privacy-link">
              Plaid Privacy
            </Link>
            <Link to="/terms" className="hover:text-emerald-400 transition-colors" data-testid="footer-terms-link">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const Section = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-bold text-emerald-900" style={{ fontFamily: "Manrope, sans-serif" }}>
      {heading}
    </h2>
    <div className="text-stone-700 leading-relaxed space-y-3 text-[15px]">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1.5 text-stone-700">
    {items.map((it, i) => (
      <li key={i}>{it}</li>
    ))}
  </ul>
);
